// React imports
import PropTypes from 'prop-types';

//  material-ui imports
import { Icon } from '@mui/material';

// project imports
import FileMngrCustomMuiIcon from './extend/FileMngrCustomMuiIcon';

// ==============================|| FILEMNGR ICON ||============================== //

const FileMngrIcon = ({ icon, size, color, ...props }) =>
    typeof icon === 'string' ? (
        <Icon sx={{ color, transform: 'scale(0.7)' }}>{icon}</Icon>
    ) : (
        <FileMngrCustomMuiIcon color={color} sx={{ fontSize: size }} {...props} icon={icon} />
    );

FileMngrIcon.propTypes = {
    icon: PropTypes.any,
    size: PropTypes.number,
    color: PropTypes.string
};

export default FileMngrIcon;
